// extracted by mini-css-extract-plugin
module.exports = {"dialogContainer":"VNConfirmDefaultTipModal_dialogContainer__30yAL"};